import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { constants, isNotEmpty, mixpanel, snowplow } from 'common/helpers'

import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import { MenuLink } from 'components/_new/ui/Menu'

import Collection from './Collection/Collection'

import s from './Collections.scss'


class HeaderSubNavDropdownCollections extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    titleProps: PropTypes.shape({
      title: PropTypes.object.isRequired,
      to: PropTypes.string,
      onClick: PropTypes.func,
    }).isRequired,
    browseAllProps: PropTypes.shape({
      title: PropTypes.object.isRequired,
      to: PropTypes.string,
      onClick: PropTypes.func,
    }),
    collections: PropTypes.arrayOf(PropTypes.object),
    placement: PropTypes.string.isRequired,
    isFetching: PropTypes.bool,
  }

  handleCollectionClick = (event, collection) => {
    const { placement } = this.props

    snowplow.track(constants.snowplowEvents.navigationMenuClick, {
      link: collection.url,
      title: collection.title,
    })
  }

  handleTitleClick = (event) => {
    const { titleProps: { onClick } } = this.props

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }

  handleBrowseAllClick = (event) => {
    const { browseAllProps: { onClick } } = this.props

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }

  render() {
    const {
      className, titleProps, browseAllProps, collections, isFetching,
      adaIndexMenu, adaIndexBrowseAll, _ref, state, setState,
    } = this.props

    return (
      <div className={cx(s.root, className)}>
        <div className={s.header}>
          <MenuLink
            className={s.title}
            title={titleProps.title}
            to={titleProps.to}
            index={adaIndexMenu}
            customColor
            onClick={this.handleTitleClick}
            _ref={_ref(adaIndexMenu)}
            {...{ state, setState }}
          />
          <MenuLink
            className={s.browseButton}
            title={browseAllProps.title}
            to={browseAllProps.to}
            index={adaIndexBrowseAll}
            customColor
            onClick={this.handleBrowseAllClick}
            _ref={_ref(adaIndexBrowseAll)}
            {...{ state, setState }}
          />
        </div>
        <div className={s.collections}>
          <ContentWithLoader className={s.loader} isFetching={isFetching}>
            {
              isNotEmpty(collections) && collections.map((item) => (
                <div key={item.id} className={s.item}>
                  <Collection
                    collection={item}
                    onClick={this.handleCollectionClick}
                    _ref={_ref(item.adaIndex)}
                    {...{ state, setState }}
                  />
                </div>
              ))
            }
          </ContentWithLoader>
        </div>
      </div>
    )
  }
}

export default HeaderSubNavDropdownCollections
